import React from 'react';
import {
  Box,
  Button,
  // Container,
  // Divider,
  Paper,
  Typography,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import VatReturnsReceivedActions from '../../redux/reducers/vatreturns_received_list_reducer/actions';
import useStyles from './styles';
import VatReturnsReceivedDatatableList from './components/datatable';
import clsx from 'clsx';
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned';
import { Translations } from './configuration';
import { VatReturnsReceivedTableDefaultFetchValues } from './components/datatable/configuration';
import NavigationConfig from 'navigation/config';
import VatReturnsReceivedListActions from 'redux/reducers/vatreturns_received_list_reducer/actions';
import useQuery from 'custom_hooks/useQuery';
import VatReturnReceivedViewModal from './components/datatable/view';
import VatReturnReceivedInfoModal from './components/datatable/infoModal';

const VatReturnsReceivedPage = (props: any) => {
  // console.log('Render VatReturnsReceived Page');
  const dispatch = useDispatch();
  const classes = useStyles();

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const originatingCountry = query.get('originatingCountry');
  const schemeType = query.get('schemeType');
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(originatingCountry && { originatingCountry }),
    ...(schemeType && { schemeType }),
  };

  React.useEffect(() => {
    dispatch(
      VatReturnsReceivedListActions.fetchMemberStateExcludeCyprusAction()
    );
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(VatReturnsReceivedActions.fetchUnreadNotificationCountAction());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(
      VatReturnsReceivedActions.fetchVatReturnsReceivedListAction({
        sortField:
          VatReturnsReceivedTableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
        page: VatReturnsReceivedTableDefaultFetchValues.TABLE_DEFAULT_PAGE,
        pageSize:
          VatReturnsReceivedTableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
        order: VatReturnsReceivedTableDefaultFetchValues.TABLE_DEFAULT_ORDER,
        ...searchParams,
      })
    );
  }, [dispatch, searchParams]);

  return (
    /*================== VatReturnsReceived Page ==================*/
    <div>
      <VatReturnReceivedViewModal />
      <VatReturnReceivedInfoModal />
      {/*================== VatReturnsReceived Page - Header ==================*/}
      <Paper
        className={clsx(classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        {/* VatReturnsReceived Page - Header - Title, Icon & Actions */}
        <Box display="flex" alignItems={'center'}>
          {/* Icon */}
          <AssignmentReturnedIcon style={{ marginRight: '.75rem' }} />
          {/* Title */}
          <Typography component={'p'} variant={'h6'}>
            <TranslatedText
              textMap={Translations.page_title}
              defaultText={Translations.page_title.English}
            />
          </Typography>
        </Box>
      </Paper>
      {/*--------------- end of VatReturnsReceived Page - Header ---------------*/}

      {/*================== VatReturnsReceived Page - Body ==================*/}
      <div style={{ padding: 12 }}>
        {/*================== VatReturnsReceived Page - Body - VatReturnsReceived Section ==================*/}
        <div className={classes.cardLayout}>
          {/* VatReturnsReceived Page - Body - VatReturnsReceived Section - Title */}
          <Typography
            component={'p'}
            variant={'h5'}
            style={{ marginBottom: '.5rem' }}
          >
            <TranslatedText
              textMap={Translations.title}
              defaultText={Translations.title.English}
            />
          </Typography>

          {/* VatReturnsReceived Page - Body - VatReturnsReceived Section - Description */}
          <Typography component={'p'} variant={'subtitle1'}>
            <TranslatedText
              textMap={Translations.description}
              defaultText={Translations.description.English}
            />
          </Typography>

          {/* VatReturnsReceived Page - Body - VatReturnsReceived Section - VatReturnsReceived List Table */}
          <div className={classes.tableList}>
            <VatReturnsReceivedDatatableList />
          </div>

          {/* VatReturnsReceived Page - Body - VatReturnsReceived Section - Buttons & Actions */}
          <Box display="flex" justifyContent="flex-end">
            <div className={classes.dashboardButton}>
              <BackToDashboardPage />
            </div>
          </Box>
        </div>
        {/*--------------- end of VatReturnsReceived Page - Body - VatReturnsReceived Section ---------------*/}
      </div>
      {/*--------------- end of VatReturnsReceived Page - Body ---------------*/}
    </div>
    /*--------------- end of VatReturnsReceived Page ---------------*/
  );
};

const BackToDashboardPage = () => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push(NavigationConfig.dashboardPage().path);
  };

  return (
    <Button
      variant="contained"
      style={{ color: '#e6e6e6', backgroundColor: '#25262d' }}
      onClick={goToDashboard}
    >
      <TranslatedText textMap={Translations.go_to_dashboard} />
    </Button>
  );
};

export default withRouter(VatReturnsReceivedPage);
